import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_INBOX_MESSAGE:
      return {
        ...state,
        isCreating: true,
      };

    case actions.CREATE_INBOX_MESSAGE_ENDED:
      return {
        ...state,
        isCreating: false,
      };

    case actions.UPDATE_INBOX_MESSAGE:
      return {
        ...state,
        isUpdating: true,
      };

    case actions.UPDATE_INBOX_MESSAGE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };

    default:
      return state;
  }
};
